import React, { ReactElement } from 'react'

import { AttachmentFilterType } from '@features/attachments/enums/attachmentFiltertype'

import { ApprovedEInvoiceEmptyState } from './elements/ApprovedEInvoiceEmptyState/ApprovedEInvoiceEmptyState'
import { BlockedEInvoiceEmptyState } from './elements/BlockedEInvoiceEmptyState'
import { EInvoicesEmptyState } from './elements/EInvoicesEmptyState'
import { NewReceipt } from './elements/NewReceipt'
import { ScoutEmptyState } from './elements/ScoutEmptyState'
import { ScoutEmptyStateMode } from './elements/ScoutEmptyState/enums/scoutEmptyStateMode'

export const ReceiptsEmptyState = ({ type }: { type: AttachmentFilterType }): ReactElement | null => {
  if (type === AttachmentFilterType.Blocked) {
    return <BlockedEInvoiceEmptyState />
  } else if (type === AttachmentFilterType.EDocument) {
    return <EInvoicesEmptyState />
  } else if (type === AttachmentFilterType.Scout) {
    return <ScoutEmptyState mode={ScoutEmptyStateMode.UploadPage} />
  } else if (type === AttachmentFilterType.Approved) {
    return <ApprovedEInvoiceEmptyState />
  }
  return <NewReceipt />
}
